import analytics from '~chatbot/analytics';

export const handleTracking = (properties, ctaType = 'cta_click', source) => {
  analytics.click(
    ctaType,
    source,
    properties,
  );
};
